<template>
    <div class="diagram-line-item">
        <div class="l-box l-box-b"></div>
        <div class="l-box l-box-b"></div>
        <div class="l-box " :class="{'l-box-w': itemType == 'yin', 'l-box-b': itemType == 'yang'}"></div>
        <div class="l-box l-box-b"></div>
        <div class="l-box l-box-b"></div>
    </div>
</template>

<script>
export default {
    name: 'DiagramLineItem',
    props: {
        itemType: {
            type: String,
            default() { return 'yang' } 
        }
    }
}
</script>